import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useUserContext } from "api/user/UserProvider";
import { useMsalEvents } from "api/user/MsalEventListener";
import BrandedFullPageLoader from "core/loader/BrandedFullPageLoader";

const Authorize = () => {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();
  const { ssoReply, token } = useUserContext();
  const { idToken } = useMsalEvents();

  useEffect(() => {
    if (ssoReply?.token) {
      window.location.href = "/login";
    }
  }, [ssoReply]);

  useEffect(() => {
    if (
      inProgress !== InteractionStatus.None ||
      idToken ||
      ssoReply?.token ||
      token
    ) {
      return;
    }
    if (instance.getAllAccounts().length === 0) {
      navigate("/login");
    }
  }, [inProgress, idToken, ssoReply, token, instance, navigate]);

  return <BrandedFullPageLoader text="Connexion en cours…" theme="sso" />;
};

export default Authorize;
